import {
  ContractEndActionEnum,
  ContractStatusEnum,
  IContract,
} from '@monetize/types/app';
import {
  CONTRACT_CANCELED_RENEWAL_MESSAGE,
  CONTRACT_STATUS_AMEND_ALLOWED,
  CONTRACT_STATUS_CANCEL_ALLOWED,
  CONTRACT_STATUS_DISPLAY,
  CONTRACT_STATUS_RENEWAL_ALLOWED,
} from '../constants/contracts';

/** Why a contract cannot be amended, or `null` when it can */
export function getAmendContractDisabledReason(
  contract: IContract,
): string | null {
  if (contract.renewed) {
    return 'This contract has already been renewed and cannot be amended.';
  }
  if (!CONTRACT_STATUS_AMEND_ALLOWED.has(contract.status)) {
    return `${CONTRACT_STATUS_DISPLAY[contract.status]} contracts cannot be amended.`;
  }
  return null;
}

/** Why a contract cannot be renewed, or `null` when it can */
export function getRenewContractDisabledReason(
  contract: IContract,
): string | null {
  if (contract.renewed) {
    return 'This contract has already been renewed.';
  }
  if (contract.status === ContractStatusEnum.CANCELED) {
    return CONTRACT_CANCELED_RENEWAL_MESSAGE;
  }
  if (!CONTRACT_STATUS_RENEWAL_ALLOWED.has(contract.status)) {
    return `${CONTRACT_STATUS_DISPLAY[contract.status]} contracts cannot be renewed.`;
  }
  return null;
}

export function canAmendContract(contract: IContract) {
  if (!contract) {
    return false;
  }
  return !getAmendContractDisabledReason(contract);
}

export function canRenewContract(contract: IContract) {
  if (!contract) {
    return false;
  }
  return !getRenewContractDisabledReason(contract);
}

export function canTurnOffAutoRenew(contract: IContract) {
  if (!contract) {
    return false;
  }
  return (
    contract.endAction === ContractEndActionEnum.RENEW &&
    contract.status === ContractStatusEnum.ACTIVE &&
    !contract.renewed
  );
}

export function canCancelContract(contract: IContract) {
  if (!contract) {
    return false;
  }
  return (
    CONTRACT_STATUS_CANCEL_ALLOWED.has(contract.status) && !contract.renewed
  );
}
